import { SortState } from "./enrichment-list.types";

/** Sort key → BFF `sortBy`. The BFF sorts by package fields only (whitelist
 *  in cxa-enricher-portal-bff `internal/enrichment/query.go`: id, name,
 *  lifecycleStatus, updatedAt, shelf, version), so every key the list offers
 *  maps to one of them.
 *
 *  `product` maps to `name`: the package name the BFF sorts by. `version` is
 *  the offering's catalog version. Product line and type are derived fields
 *  the BFF cannot sort by. */
export const BACKEND_SORT_FIELDS: Record<string, string> = {
  offeringCode: "id",
  name: "name",
  product: "name",
  updated: "updatedAt",
  version: "version",
};

/** The `{ sortBy, sortDir }` query params for a sort key, or null for a key
 *  the BFF cannot sort by. */
export function buildSortParam(
  sort: SortState,
): { sortBy: string; sortDir: "asc" | "desc" } | null {
  const beField = BACKEND_SORT_FIELDS[sort.key];
  return beField ? { sortBy: beField, sortDir: sort.dir } : null;
}
